import { Link } from "react-router-dom";

export interface Crumb {
  label: string;
  to?: string;
}

export default function PageHeader({
  crumbs,
  title,
  subtitle,
}: {
  crumbs: Crumb[];
  title: string;
  subtitle?: string;
}) {
  return (
    <section className="relative overflow-hidden bg-background-100 border-b border-background-300/50">
      <div className="absolute inset-0 bg-gradient-to-br from-primary-700/25 via-transparent to-transparent"></div>
      <div className="absolute -top-16 right-10 h-48 w-48 rounded-full bg-primary-600/20 blur-3xl"></div>
      <div className="absolute top-10 right-40 h-32 w-32 rounded-full bg-accent-500/10 blur-2xl"></div>
      <div className="relative mx-auto max-w-7xl px-4 md:px-6 py-12 md:py-16">
        <nav aria-label="面包屑" className="flex flex-wrap items-center gap-1.5 text-sm text-foreground-600 mb-5">
          {crumbs.map((c, i) => (
            <span key={i} className="flex items-center gap-1.5">
              {c.to ? (
                <Link to={c.to} className="hover:text-primary-400 transition-colors">{c.label}</Link>
              ) : (
                <span className="text-foreground-500">{c.label}</span>
              )}
              {i < crumbs.length - 1 && <i className="ri-arrow-right-s-line text-foreground-700"></i>}
            </span>
          ))}
        </nav>
        <h1 className="font-heading text-3xl md:text-5xl text-foreground-950">{title}</h1>
        {subtitle && (
          <p className="mt-4 max-w-2xl text-sm md:text-base leading-relaxed text-foreground-600">{subtitle}</p>
        )}
      </div>
    </section>
  );
}